import React from 'react'
import SEOHead from '@/components/SEO/SEOHead'
import HeroSection from '@/components/Home/HeroSection'
import ServicesSection from '@/components/Home/ServicesSection'
import TestimonialsSection from '@/components/Home/TestimonialsSection'
import ContactSection from '@/components/Home/ContactSection'
import { buildGraph, breadcrumbListData, faqData } from '@/data/structured-data'

const HomePage: React.FC = () => {
  const structuredData = buildGraph(
    breadcrumbListData([{ name: 'Ana Sayfa', url: '/' }]),
    faqData([
      {
        question: 'Şanlıurfa’da 7/24 acil veteriner hizmeti veriyor musunuz?',
        answer: 'Evet. Ardıç Veteriner Kliniği olarak Karaköprü/Şanlıurfa’da acil vakalar için 7/24 ulaşılabiliriz. Telefon veya WhatsApp üzerinden hemen bize yazabilirsiniz.'
      },
      {
        question: 'Kliniğinizin çalışma saatleri nedir?',
        answer: 'Hafta içi 09:00 - 19:00, hafta sonu 09:00 - 17:00 saatleri arasında hizmet veriyoruz. Acil durumlar için mesai dışında da ulaşılabilir durumdayız.'
      },
      {
        question: 'Kliniğiniz nerede?',
        answer: 'Batıkent Mahallesi Çardaklıkaya Bulvarı, Fuar Alanı Kavşağı, Karaköprü/Şanlıurfa adresindeyiz.'
      }
    ])
  )

  return (
    <>
      <SEOHead
        title="Ardıç Veteriner Kliniği - Şanlıurfa | Ana Sayfa"
        description="Şanlıurfa'nın en modern veteriner kliniği. Kedi ve köpek sağlığı için 7/24 acil hizmet, uzman kadro ve güvenilir tedavi."
        keywords="şanlıurfa veteriner, sanliurfa veteriner, urfa veteriner, şanlıurfa veteriner kliniği, acil veteriner, 7 24 veteriner, gece açık veteriner, nöbetçi veteriner şanlıurfa, veteriner telefon numarası, veteriner numaralari, kedi kısırlaştırma ücreti 2024, köpek kısırlaştırma fiyatları, kedi aşı fiyatları, köpek aşı takvimi, hayvan kliniği, veteriner klinigi"
        canonicalUrl="https://ardicvet.com/"
        ogImage="/og-image.jpg"
        structuredData={structuredData}
      />

      <HeroSection />
      <ServicesSection />
      <TestimonialsSection />
      <ContactSection />
    </>
  )
}

export default HomePage
